import React, { useState } from "react";
import About from "./About";
import Experience from "./Experience";
import Project from "./Project";
import Skill from "./Skill";
import Contact from "./Contact";
import { ProjectShowCase } from "styles/projectTab";
import { IoPersonSharp } from "react-icons/io5";
import { FaLaptopCode } from "react-icons/fa";
import { GiSkills } from "react-icons/gi";
import { MdOutlineConnectWithoutContact } from "react-icons/md";
import { CgWorkAlt } from "react-icons/cg";
import { IoSchool } from "react-icons/io5";
import Education from "./Education";

const MainTab = () => {
  const [currentTabs, setCurrentTabs] = useState("About");
  const tabs = [
    {
      name: "About",
      content: <About />,
      icon: <IoPersonSharp size={30} />,
    },
    {
      name: "Education",
      content: <Education />,
      icon: <IoSchool size={30} />,
    },
    {
      name: "Experience",
      content: <Experience />,
      icon: <CgWorkAlt size={30} />,
    },
    {
      name: "Projects",
      content: <Project />,
      icon: <FaLaptopCode size={30} />,
    },
    {
      name: "Skills",
      content: <Skill />,
      icon: <GiSkills size={30} />,
    },
    {
      name: "Contact",
      content: <Contact />,
      icon: <MdOutlineConnectWithoutContact size={30} />,
    },
  ];
  return (
    <div>
      <div className="new-tab-container">
        <div className="new-tab">
          {tabs.map((tab, i) => (
            <button
              className="tab-btn"
              key={i}
              name={tab.name}
              disabled={currentTabs === `${tab.name}`}
              onClick={() => setCurrentTabs(tab.name)}
              style={{
                backgroundColor:
                  currentTabs === tab.name
                    ? "var(--color-active-btn)"
                    : "#3B3729",
                color: currentTabs === tab.name ? "#000" : "#A89D9D",
              }}
            >
              {tab.icon}
              {tab.name}
            </button>
          ))}
        </div>
        <div
          className="teacher-content"
          style={{
            width: "100%",
          }}
        >
          {tabs.map((tab, i) => (
            <ProjectShowCase key={i}>
              {currentTabs === `${tab.name}` && tab.content}
            </ProjectShowCase>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MainTab;
